import { createFileRoute } from '@tanstack/react-router';

import { SecureLinkExpired, SecureLinkGate } from '../auth/secure-link';
import { useAppNavigate } from '../lib/session/navigate';

/**
 * `/auth/secure-link#token=…` — the standalone landing page of a portal link (M10.2).
 *
 * Most links do not come here: `SecureLinkService.mint` returns the *destination* with the
 * token appended, so a reminder's "reschedule" link is
 * `/account/appointments/<id>/reschedule#token=…` and the gate on the `/account` layout
 * spends it there. This route is the address a link can be sent to when there is no
 * destination yet — and the page a patient lands on when a mail client rewrote the URL
 * into something the portal does not route.
 *
 * Reaching it with **no** token is therefore not an empty state: it is a link that did not
 * survive the journey, and it gets the same sentence every other failure gets. There is
 * nothing here to render otherwise, so the gate's children are the refusal.
 */
export const Route = createFileRoute('/auth/secure-link')({
  component: SecureLinkRoute,
});

function SecureLinkRoute() {
  const navigate = useAppNavigate();

  return (
    <SecureLinkGate
      onSignedIn={(path) => {
        navigate(path, { replace: true });
      }}
      onNavigate={navigate}
    >
      <SecureLinkExpired onNavigate={navigate} />
    </SecureLinkGate>
  );
}
